import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticleGuide from "@/pages/article/page";
import QCGuide from "@/pages/article/qc-guide/page";
import ShippingDe from "@/pages/article/shipping-deutschland/page";
import VsAlternatives from "@/pages/article/vs-alternatives/page";
import Sneaker from "@/pages/article/sneaker/page";
import Hoodie from "@/pages/article/hoodie/page";
import Anfaenger from "@/pages/article/anfaenger/page";
import Preisvergleich from "@/pages/article/preisvergleich/page";
import SicherEinkaufen from "@/pages/article/sicher-einkaufen/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-guide",
    element: <ArticleGuide />,
  },
  {
    path: "/artikel/oopbuy-qc-guide",
    element: <QCGuide />,
  },
  {
    path: "/artikel/oopbuy-shipping-deutschland",
    element: <ShippingDe />,
  },
  {
    path: "/artikel/oopbuy-vs-alternatives",
    element: <VsAlternatives />,
  },
  {
    path: "/artikel/oopbuy-sneaker-spreadsheet",
    element: <Sneaker />,
  },
  {
    path: "/artikel/oopbuy-hoodie-spreadsheet",
    element: <Hoodie />,
  },
  {
    path: "/artikel/oopbuy-anfaenger-tipps",
    element: <Anfaenger />,
  },
  {
    path: "/artikel/oopbuy-preisvergleich-tipps",
    element: <Preisvergleich />,
  },
  {
    path: "/artikel/oopbuy-sicher-einkaufen",
    element: <SicherEinkaufen />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;